import assessmentReader from '../store/readHelpers/AssessmentReader';
import scrollingService from './../services/ScrollingService';


const stimulusHighlightsService = {
    goToHighlight(question, hasHighlightsInSection, mode, questionContentItemId) {
        let scrollToElement;
        let currentHighlightContentItemId;

        if (mode === 'question' && questionContentItemId) {
            currentHighlightContentItemId = questionContentItemId;
        } else {
            currentHighlightContentItemId = question.contentItemId;
        }
        const highlights = Array.from(
            document.querySelectorAll('[class*="highlight--id-"]')
        );
        highlights.forEach((highlight) => {
            if (highlight.classList.contains(`highlight--id-${currentHighlightContentItemId}`)) {
                if (!scrollToElement) {
                    scrollToElement = highlight;
                }
                highlight.classList.add('in-view');
            } else {
                highlight.classList.remove('in-view');
            }
        });
        if (!hasHighlightsInSection) {
            return false;
        }
        const { sectionId } = assessmentReader.getQuestionWithIndexAndSectionId(question.contentRevisionId);
        if (sectionId) {
            return scrollingService.scrollToElement(scrollToElement, 300, 0, `stimulus-wrapper-${sectionId}`);
        }
        return false;
    },
};

export default stimulusHighlightsService;
